export default "/v8.53.2/69cea3e/bundles/manifest.json";